import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  getOrgTemplateLibraries,
  getProject,
  updateProject,
} from 'src/redux/slices/project/endpoints'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import { Box, MenuItem, TextField, Typography } from '@material-ui/core'

const CloudTemplateLibSelector: React.FC = () => {
  // Load the current organization's available template libraries
  const { data: orgTemplateLibs, isLoading: isLoadingOrgTemplatLibs } =
    getOrgTemplateLibraries.useQuery('')

  // Load the current project data
  const { data: project, isLoading: isLoadingProject } = getProject.useQuery('')

  // Mutation for updating the project's selected lib
  const [triggerUpdateProject, { isLoading: isUpdatingProject, data: projectUpdateData }] =
    updateProject.useMutation({ fixedCacheKey: 'updateProject' })

  // State for merging selected value with select field value
  const [selectedTemplateLibId, setSelectedTemplateLibId] = useState<number | null>(null)

  // merge values
  const value = useMemo(() => {
    if (selectedTemplateLibId) return selectedTemplateLibId
    if (project?.template_lib_id) return project.template_lib_id
    return ''
  }, [project?.template_lib_id, selectedTemplateLibId])

  // Callback for changing the template
  const changeSelectedTemplateLibrary = useCallback(
    (e: TextFieldOnChangeEvent) => {
      setSelectedTemplateLibId(Number(e.target.value))
    },
    [setSelectedTemplateLibId],
  )

  // Mutate the project when the selection changes
  useEffect(() => {
    if (!project) return
    if (value && value != project?.template_lib_id) {
      triggerUpdateProject({ template_lib_id: value })
    }
  }, [value, project?.template_lib_id, triggerUpdateProject])

  return (
    <Box>
      <Typography>Select one of your team's Template Libraries for use in this project.</Typography>
      {orgTemplateLibs && (
        <TextField
          label='Template Library'
          select
          id='cloud-template-lb-selector'
          onChange={changeSelectedTemplateLibrary}
          fullWidth
          helperText='nb: each project can only use one user library in addition to the standard D.o.E. reference library'
          value={value}
        >
          {orgTemplateLibs.map(({ title, file_location, id }) => (
            <MenuItem key={`lib-${title}-${id}`} value={id}>
              {title}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Box>
  )
}

export default CloudTemplateLibSelector
